// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"content_wrapper__QANwB","separator":"content_separator__1o7XF"};